// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__VqLRt","choiceBoxes":"toolbarselects_choiceBoxes__3yUcK","simpleField":"toolbarselects_simpleField__1z9lG"};